import { render } from "./CityListItem.vue?vue&type=template&id=45554656&scoped=true"
import script from "./CityListItem.vue?vue&type=script&lang=js"
export * from "./CityListItem.vue?vue&type=script&lang=js"

import "./CityListItem.vue?vue&type=style&index=0&id=45554656&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-45554656"

export default script